const PERMISSION_KEY= "company:config_system";
const PAGE_URL = {
    CONFIG_SYSTEM_PAGE: "/admin/company/config-system"
}

export {PERMISSION_KEY, PAGE_URL}

